import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Menu, X, Waves } from 'lucide-react'
import { cn } from '@/utils/cn'

const NAV_LINKS = [
  { href: '/ferienwohnung', label: 'Ferienwohnung' },
  { href: '/lage',          label: 'Lage' },
  { href: '/preise',        label: 'Preise' },
  { href: '/anreise',       label: 'Anreise' },
  { href: '/kontakt',       label: 'Kontakt' },
]

export function Header() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-neutral-100 shadow-sm">
      <div className="container-content">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <NavLink
            to="/"
            className="flex items-center gap-2 font-heading font-bold text-primary-DEFAULT text-lg leading-none"
            aria-label="Ferienwohnung Familie Below – Startseite"
          >
            <Waves size={22} className="text-primary-DEFAULT" aria-hidden="true" />
            <span className="hidden xs:block">Familie Below</span>
            <span className="xs:hidden">Below Bansin</span>
          </NavLink>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1" aria-label="Hauptnavigation">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.href}
                to={link.href}
                className={({ isActive }) =>
                  cn(
                    'nav-link px-3 py-2 rounded-md text-sm',
                    isActive && 'text-primary-DEFAULT font-semibold bg-primary-50',
                  )
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href="/preise"
              className="btn-primary ml-3 text-sm px-4 py-2"
            >
              Jetzt anfragen
            </a>
          </nav>

          {/* Mobile hamburger */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-[#2C2C2C] hover:bg-neutral-100"
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? 'Menü schließen' : 'Menü öffnen'}
          >
            {open ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div id="mobile-menu" className="md:hidden border-t border-neutral-100 bg-white">
          <nav className="container-content py-4 flex flex-col gap-1" aria-label="Mobile Navigation">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.href}
                to={link.href}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  cn(
                    'nav-link px-4 py-3 rounded-lg text-base',
                    isActive && 'text-primary-DEFAULT font-semibold bg-primary-50',
                  )
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href="/preise"
              className="btn-primary mt-2 text-center"
              onClick={() => setOpen(false)}
            >
              Jetzt anfragen
            </a>
          </nav>
        </div>
      )}
    </header>
  )
}
